import { useMutation, useQuery} from '@tanstack/react-query';
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useLoginApi } from '../../Hooks/useLoginApi';
import { useQueryParams } from '../HelperFunction/Hooks/useQueryParams';
import { useEffect } from 'react';

export const getSpecialUserDetails = ({
  isMainScreen = false,
  initialData,
  key,
  enabled = true,
}: {
  initialData?: any;
  isMainScreen?: boolean;
  key?: any;
  enabled?: boolean;
}) => {
  const { query, queryhash, setFilters, filters, setQuery, updateQuery } =
    useQueryParams<any>({
      isMainScreen,
      initialData,
    });
  const { getSpecialUser } = useLoginApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getUseDetails', queryhash, key],
    queryFn: () => {
      const { page, limit, ...filteredQuery } = query;
      return getSpecialUser(filteredQuery);
    },
    enabled,
  });

  useEffect(() => {
    if (queryhash) {
      refetch();
    }
  }, [queryhash, refetch]);

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    query,
    setQuery,
    filters,
    setFilters,
    refetch,
    updateQuery,
  };
};

export const CreateLogin = () => {
  const { showMessage } = useSnackbar();
  const { createLogin } = useLoginApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createLogin(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Loged In successfully',
        'success'
      );
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to login',
        'error'
      );
    },
  });
};